import { AxiosError } from 'axios';
import React from 'react';

// import Loading from 'components/atoms/Loading';
import ErrorContainer from 'container/Error';
import usePreview from 'hooks/usePreview';
import { RenderPage } from 'navigation';
import { getStaticHomeService } from 'services/navigation';

const Home: React.FC = () => {
  const { data, error } = usePreview({
    name: 'GetHomeData',
    cb: () => getStaticHomeService(),
  });

  // if (isLoading) {
  //   return (
  //     <div className="d-flex justify-content-center">
  //       <Loading isBlock />
  //     </div>
  //   );
  // }

  if (error) {
    return (
      <ErrorContainer statusCode={(error as AxiosError)?.response?.status} />
    );
  }

  return (
    <RenderPage data={data} />
  );
};

export default Home;
